<template>
  <div :key="renderKey">
    <div class="row">
      <el-table style="font-size:12px;text-wrap: wrap;" :data="options" role="table" aria-label="User Documents Table">
        <el-table-column v-if="!editable" :min-width="150" align="left" label="Actions">
          <div slot-scope="props">
            <el-tooltip v-if="$route.path != '/Account/UserProfile'" content="Edit Document" :open-delay="300"
              effect="light" placement="top">
              <a href="##" @click.stop.prevent="handleEdit(props.row)" class="btn-link btn-danger">
                <i class="tim-icons icon-pencil"></i>
              </a>
            </el-tooltip>
            <span v-if="$route.path != '/Account/UserProfile'" class="hide-if-medium-screensize">|</span>

            <el-tooltip content="Delete Document" class="display-inline" :open-delay="300" effect="light"
              placement="top">
              <a href="##" @click.stop.prevent="handleDelete(props.row.id, props.row.name)" class="btn-link btn-danger">
                <i class="tim-icons icon-trash-simple"></i>
              </a>
            </el-tooltip>

            <span class="hide-if-medium-screensize">|</span>
            <el-tooltip content="Download Document" :open-delay="300" effect="light" placement="top">
              <router-link :to="`/api/applicationuserfiles/${props.row.id}`" class="btn-link btn-primary"
                target="_blank">
                <i class="tim-icons icon-cloud-download-93"></i>
              </router-link>
            </el-tooltip>

          </div>

        </el-table-column>

        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" sortable
          :formatter="column.formatter" :prop="column.prop" :label="column.label">

        </el-table-column>
        <el-table-column min-width="150" sortable label="UPLOAD DATE">

          <template slot-scope="scope">
            {{ formatDate(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" sortable label="Document Date">
          <editable-cell :show-input="row.id == editingRowId" slot-scope="{ row }" v-model="row.documentDate"
            size="mini" type="date" @change="updateAdminUserFiles(row.id, row.userId, row.documentDate)">
            <span slot="content">{{
              row.documentDate != null
                ? formatDateLocalTime(row.documentDate)
                : ""
            }}</span>
          </editable-cell>

        </el-table-column>
      </el-table>
    </div>
    <div class="row align-center">
      <UserDocumentsModal :email="email" :isNew="true" :type="type" @reloadDocuments="reRenderDocuments()">
        <template v-slot:modal-link>
          <base-button :disabled="editable" class="btn-dark"><span><i class="tim-icons icon-simple-add"></i> Add
              Documentation</span></base-button>
        </template>
      </UserDocumentsModal>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import Util from "@/util/util";
import moment from "moment";
import { BaseSwitch, BaseButton, Modal, EditableCell } from "@/components";
import UserDocumentsModal from "@/components/App/account/documents/UserDocumentsModal.vue";
import UserDocumentsDelete from "@/components/App/account/documents/UserDocumentsDelete.vue";
import swal from "sweetalert2";
const options = {
  'Content-Type': 'application/json',
  config: { showToast: false }
};
export default {
  name: "UserDocuments",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    UserDocumentsModal,
    EditableCell,
    UserDocumentsDelete,
  },

  props: {
    email: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    renderKey: 0,
    tableColumns: [
      {
        prop: "name",
        label: "NAME",
        minWidth: 100,
        scope: "col"
      },
      {
        prop: "type",
        label: "TYPE",
        minWidth: 100,
        scope: "col"
      },
    ],
    editMode: false,
    editingRowId: null,
  }),
  watch: {
    async email(newEmail, oldEmail) {
      if (newEmail !== oldEmail) {
        await this.reRenderDocuments();
      }
    },
  },
 async  mounted() {
    this.options = [];
   await  this.reRenderDocuments();
  },
  methods: {
   async  reRenderDocuments() {
      if (this.email) {
        // Admin Profile
      await  this.getAdminUserFiles();
      } else {
        // User Profile
       await this.getFiles();
      }
    },
    async handleEdit(row) {
      if (this.editingRowId === row.id) {
        // Row Updating Section
        this.editMode = false;
        this.editingRowId = null;
      } else {
        this.editMode = true;
        this.editingRowId = row.id;
      }
    },
    async deleteAndRerender(fileId) {
      await this.axios.delete(`api/applicationuserfiles/delete/${fileId}`);
      await this.reRenderDocuments();
    },
    handleDelete(fileId, nameOfFile) {
      new swal({
        title: "Delete File",
        html: `Do you want to delete ${nameOfFile}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.deleteAndRerender(fileId);
        }
      });
    },
    formatDate(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
    formatDateLocalTime(value) {
      return moment(value).format("MMMM DD, YYYY");
    },
   async  getAdminUserFiles() {
      let ctx = this;
      const encodedEmail = encodeURIComponent(ctx.email); // Bug-fix #17661

     await ctx.axios
        .get(`api/applicationuserfiles/user/email/${encodedEmail}`, options)
        .then( (response) => {
          //Load the data
           ctx.options = response.data.map((old) => {
            return {
              id: old.id,
              userId:old.userId,
              name: old.filename,
              type: old.filetype,
              expiration: old.expiration,
              createDate: old.createDate,
              updateDate: old.updateDate,
              documentDate: old.documentDate

            };
          });
        });
    },
    updateAdminUserFiles(id, userId, date) {
      let ctx = this;
      let formData = new FormData();
      formData.append('DocumentDate', new Date(date).toISOString());
       formData.append('UserId', userId);
 
      // for user profile/regristrations we just want to allowe the urer end point
      // for everyone else pass through the admin validations
      // if no type is passed we also assum its personal
      let url = (!this.type || this.type === "personal") 
      ? `api/applicationuserfiles/user/${id}` : `api/applicationuserfiles/admin/${id}`;

      ctx.axios
        .put(url, formData, options)
        .then(async (response) => {
          // get 
          //Load the data
          await ctx.reRenderDocuments();
           ctx.$toast.success("Document updated successfully");
        }
      ).catch(async (error) => {
    ctx.$toast.error("Error updating document");
     await ctx.reRenderDocuments();
  });
      this.editMode = false;
      this.editingRowId = null;
    },
   async  getFiles() {
     await  this.axios.get(`api/applicationuserfiles/user/email`, options).then((response) => {
        //Load the data
        this.options = response.data.map((old) => {
          return {
            id: old.id,
            name: old.filename,
            type: old.filetype,
            expiration: old.expiration,
            createDate: old.createDate,
            updateDate: old.updateDate

          };
        });
      });
    },
  },
};
</script>

<style scoped>
/* This is for "Delete | Download" type of styling in AGATRS */

@media only screen and (max-width: 1510px) {
  .hide-if-large-screensize {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .hide-if-medium-screensize {
    display: none;
  }
}
</style>
